<div [class]="['root', headwayWidgetClassName]">
  <button mat-icon-button type="button" class="button">
    <mat-icon class="-header-icon">fiber_new</mat-icon>
  </button>
</div>
